import { useMemo } from 'react'
import { useCompaniesList, useCompany } from '@/features/companies/api/company-queries'
import type { CompanyCard, CompanyDetail } from '@/features/companies/types'

export function mergeCompanySelectOptions(
  activeCompanies: CompanyCard[],
  selectedCompanyId: string,
  selectedCompanyDetail: CompanyDetail | undefined,
): CompanyCard[] {
  const items = [...activeCompanies]
  if (
    selectedCompanyId &&
    !items.some((c) => c.id === selectedCompanyId) &&
    selectedCompanyDetail?.id === selectedCompanyId
  ) {
    items.unshift({
      ...selectedCompanyDetail,
      campaignCount: 0,
      lastActivity: selectedCompanyDetail.updatedAt,
    })
  }
  return items
}

/** Active company options + prefilled selection for Step 1 (BFP-1010). */
export function useCampaignSetupCompanyOptions(
  companyIdVal: string | undefined,
  locked: boolean,
) {
  const { data: companiesList } = useCompaniesList({
    page: 1,
    pageSize: 100,
    search: '',
    status: 'active',
  })
  const selectedCompanyId = companyIdVal?.trim() || ''
  const { data: selectedCompanyDetail } = useCompany(selectedCompanyId)
  const activeCompanies = companiesList?.items ?? []
  const options = useMemo(
    () =>
      mergeCompanySelectOptions(
        activeCompanies,
        selectedCompanyId,
        selectedCompanyDetail,
      ),
    [activeCompanies, selectedCompanyId, selectedCompanyDetail],
  )

  return {
    options,
    locked,
    fallbackName: selectedCompanyDetail?.name,
  }
}
